module.exports = __webpack_public_path__ + "static/media/lock.8b5341bd.jpg";